import { AppConfig } from '@/utils/AppConfig';
import { DirectusConfiguration } from '../types';
import fetcher from '../utils/fetcher';
import { InstantMeiliSearchInstance, instantMeiliSearch } from '@meilisearch/instant-meilisearch';

const directusConfigurationUrl = `${AppConfig.directusPublicUrl}/items/configuration`;
let client: InstantMeiliSearchInstance | null = null;

const initializeClient = async () => {
  if (client) {
    return client;
  }

  const {
    data: { key_ms },
  } = await fetcher<DirectusConfiguration>(directusConfigurationUrl);

  const { searchClient } = instantMeiliSearch(AppConfig.meilisearchPublicUrl, key_ms, {
    finitePagination: true,
  });

  client = searchClient;

  return client;
};

export default initializeClient;
